import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { Button } from 'foundations-components/transitional/components/Button';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { Text } from 'foundations-components/components/Text';
import CosUsageList from 'ui-forms-components/usageList/CosUsageList';
import { getDeleteLangKey } from 'asset-actions-lib-forms/utils/getLangKey';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function FormDeleteCosAlertModal({
  modalProps,
  handleClose,
  formType,
  pagesForForm,
  formName
}) {
  return /*#__PURE__*/_jsxs(Modal, Object.assign({
    "data-test-id": "form-delete-cos-alert-modal",
    onEsc: handleClose
  }, modalProps, {
    children: [/*#__PURE__*/_jsxs(DialogHeader, {
      children: [/*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: handleClose
      }), /*#__PURE__*/_jsx(Text, {
        as: "h2",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: getDeleteLangKey(formType, 'cosAlert.dialogHeader')
        })
      })]
    }), /*#__PURE__*/_jsxs(DialogBody, {
      children: [/*#__PURE__*/_jsx(Alert, {
        marginBlockEnd: "400",
        type: "danger",
        titleText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: getDeleteLangKey(formType, 'cosAlert.alertHeading')
        }),
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: getDeleteLangKey(formType, 'cosAlert.alertDescription'),
          options: {
            count: pagesForForm.length,
            formName
          }
        })
      }), /*#__PURE__*/_jsx(CosUsageList, {
        pages: pagesForForm
      })]
    }), /*#__PURE__*/_jsx(DialogFooter, {
      children: /*#__PURE__*/_jsx(Button, {
        use: "primary",
        onClick: handleClose,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "assetActionsLib.modals.shared.okayButton"
        })
      })
    })]
  }));
}